import { getMetaSiteLink } from '../services/apis';
import { getIsBusinessFirst } from '../selectors/metaSite';
import { useInstallerContext } from '../context/InstallerContext';
import { getCreateSiteLink } from '../utils/postInstallation';
import { usePanorama } from '../context/PanoramaContext';
export const useHandleBusinessFirst = () => {
  const {
    httpClient,
    preInstallationData: {
      authorizationHeader
    }
  } = useInstallerContext();
  const {
    startTransaction,
    finishTransaction,
    errorMonitor
  } = usePanorama();
  const requestOptions = authorizationHeader ? {
    headers: {
      authorization: authorizationHeader
    }
  } : undefined;
  return async requiredActions => {
    const createSiteLink = getCreateSiteLink(requiredActions);
    if (createSiteLink) {
      try {
        startTransaction('get-meta-site-for-biz-first');
        const metaSite = await httpClient.get(getMetaSiteLink(), requestOptions);
        const isBusinessFirst = getIsBusinessFirst(metaSite == null ? void 0 : metaSite.data);
        return isBusinessFirst ? createSiteLink : '';
      } catch (e) {
        var _errorMonitor;
        (_errorMonitor = errorMonitor({
          source: 'get-meta-site-for-biz-first'
        })) == null || _errorMonitor.reportError(e);
        return;
      } finally {
        finishTransaction('get-meta-site-for-biz-first');
      }
    }
    return;
  };
};
//# sourceMappingURL=useHandleBusinessFirst.js.map